const hash = (s) => {
  let h = 7;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

const portrait = (it) => it && it.aspect === "portrait";

// Deterministic photo-book pagination: same items in same order -> same pages.
export function buildPages(items) {
  const pages = [];
  let i = 0;
  while (i < items.length) {
    const rest = items.length - i;
    const [a, b] = [items[i], items[i + 1]];
    const roll = hash(a.id) % 10;
    let layout;
    let n;
    if (rest === 1 || roll < 2) {
      layout = portrait(a) ? "single" : "single-framed";
      n = 1;
    } else if (roll < 4 || rest === 2) {
      layout = portrait(a) && portrait(b) ? "duo-cols" : "duo-rows";
      n = 2;
    } else if (roll < 7 || rest === 3) {
      layout = portrait(a) ? "hero-left" : "hero-top";
      n = 3;
    } else {
      layout = "quad";
      n = 4;
    }
    pages.push({ key: a.id, layout, items: items.slice(i, i + n) });
    i += n;
  }
  return pages;
}
